import { makeAutoObservable } from 'mobx';
import { IBusinessHeaderData } from '../interfaces/business-card.interface';
import { BookingApi, BusinessApi } from 'shared/api';
import { IPointMiniCardDto } from 'shared/api/business/interfaces/point-mini-card-dto.interface';
import { ICardManagerInfo } from 'shared/ui/manager-mini-card/manager-mini-card.interface';
import { ICardAdministratorInfo } from 'shared/ui/administrator-mini-card/administrator-mini-card.interface';
import { IPointHeaderData } from '../interfaces/point-card.interface';
import { IServicesCard } from 'shared/api/booking/interfaces/services-list.interface';
import { IServiceCategory } from 'shared/api/booking/interfaces/service-categories.interface';
import { IEmployeeInfo } from 'shared/api/business/interfaces/employee-info.interface';
import { IUpdateBusinessDto } from 'shared/api/business/interfaces/update-business-info-dto.interface';
import { IUpdatePointDto } from 'shared/api/business/interfaces/update-point-info-dto.interface';

class BusinessStore {
  businessHeaderData?: IBusinessHeaderData;
  pointHeaderData?: IPointHeaderData;
  pointsWidgetData?: IPointMiniCardDto[];
  administratorsWidgetData?: ICardAdministratorInfo[];
  managersBusinessWidgetData?: ICardManagerInfo[]; // переписать на 2 разных интерфейса
  managersPointWidgetData?: ICardManagerInfo[];
  employeesWidgetData?: IEmployeeInfo[];
  servicesList?: IServicesCard[];
  serviceCategories?: IServiceCategory[];
  private _businessId?: string;
  private _pointId?: string;
  constructor() {
    makeAutoObservable(this);
  }

  get businessId() {
    this._businessId = localStorage.getItem('businessId') ?? undefined;
    return this._businessId;
  }
  set businessId(id: string | undefined) {
    this._businessId = id;
    if (id) {
      localStorage.setItem('businessId', id);
    } else {
      localStorage.removeItem('businessId');
    }
  }
  get pointId() {
    return (
      this._pointId ??
      localStorage.getItem('pointId') ??
      this.pointHeaderData?.id
    );
  }
  set pointId(id: string | undefined) {
    this._pointId = id;
    if (id) {
      localStorage.setItem('pointId', id);
    } else {
      localStorage.removeItem('pointId');
    }
  }
  initBusinessHeaderData(businessId: string) {
    BusinessApi.getBusinessHeaderInfo({ businessId, currentTime: new Date() })
      .then((res) => {
        this.businessHeaderData = res;
        localStorage.setItem('businessId', res.id);
      })
      .catch(() => {
        this.businessHeaderData = undefined;
      });
  }
  initPointHeaderData(pointId: string) {
    BusinessApi.getPointHeaderInfo({ pointId, currentTime: new Date() })
      .then((res) => {
        this._pointId = res.id;
        this.pointHeaderData = res;
        localStorage.setItem('pointId', res.id);
      })
      .catch(() => {
        this.pointHeaderData = undefined;
      });
  }

  updateBusinessHeaderData(data: IUpdateBusinessDto) {
    return BusinessApi.updateBusinessInfo(data).then((res) => {
      this.businessHeaderData = res;
    });
  }

  updatePointHeaderData(data: IUpdatePointDto) {
    return BusinessApi.updatePointInfo(data).then((res) => {
      this.pointHeaderData = res;
    });
  }
  initPointsWidgetData(businessId: string) {
    BusinessApi.getPointsInfo({ businessId })
      .then((res) => {
        this.pointsWidgetData = res;
      })
      .catch(() => {
        this.pointsWidgetData = undefined;
      });
  }

  initManagersBusinessWidgetData(businessId: string) {
    BusinessApi.getManagersInfoForBusiness({ businessId })
      .then((res) => {
        this.managersBusinessWidgetData = res;
      })
      .catch(() => {
        this.managersBusinessWidgetData = undefined;
      });
  }

  initManagersPointWidgetData(pointId: string) {
    BusinessApi.getManagersInfoForPoint({ pointId })
      .then((res) => {
        this.managersPointWidgetData = res;
      })
      .catch(() => {
        this.managersPointWidgetData = undefined;
      });
  }

  initAdministratorsWidgetData(businessId: string) {
    BusinessApi.getAdministratorsInfo({ businessId })
      .then((res) => {
        this.administratorsWidgetData = res;
      })
      .catch(() => {
        this.administratorsWidgetData = undefined;
      });
  }

  initEmployeesWidgetData(pointId: string) {
    BusinessApi.getEmployeesInfo({ pointId })
      .then((res) => {
        this.employeesWidgetData = res;
      })
      .catch(() => {
        this.employeesWidgetData = undefined;
      });
  }

  initServicesList(pointId: string) {
    BookingApi.getServiceList({ pointId })
      .then((res) => {
        this.servicesList = res;
      })
      .catch(() => {
        this.servicesList = undefined;
      });
  }

  initServiceCategories(pointId: string) {
    BookingApi.getServiceCategories({ pointId })
      .then((res) => {
        this.serviceCategories = res;
      })
      .catch(() => {
        this.serviceCategories = undefined;
      });
  }

  clearAllData() {
    this.businessHeaderData = undefined;
    this.pointHeaderData = undefined;
    this.pointsWidgetData = [];
    this.administratorsWidgetData = [];
    this.managersBusinessWidgetData = [];
    this.managersPointWidgetData = [];
    this.employeesWidgetData = [];
    this.servicesList = [];
    this.serviceCategories = [];
  }
}

export const businessStore = new BusinessStore();
